module.exports = __webpack_public_path__ + "img/4d5704fecb121ccea3c70bf5138c1a60.svg";